
var lib_geometry = require("lib-geometry");

var SVGToMesh = function(){

    var geometryTriggers = [];
    geometryTriggers.push(this.segmentedGeometry);
    if(this.fill)geometryTriggers.push(this.fill);
    if(this.strokeWidth)geometryTriggers.push(this.strokeWidth);

    this.complexGeometry = this.deepCachedFunction("complexGeometry",
        function(info){
            var precision = (info && info.silkscreenPrecision)? info.silkscreenPrecision : 3;
            var silkscreenEndSegments = (info && info.silkscreenEndSegments)? info.silkscreenEndSegments : 3;
            
            if(this.fill && this.fill()){
                if(this.strokeWidth() != 0){
                    var complex = this.segmentedGeometry(precision).close().toOutlineGeometry(this.strokeWidth(), silkscreenEndSegments);
                    return new lib_geometry.Polygon(complex.points);
                } else {
                    return new lib_geometry.Polygon(this.segmentedGeometry(precision).close().points);
                }
                
            } else {
                if(this.closed && !this.closed()){
                     return this.segmentedGeometry(precision).toOutlineGeometry(this.strokeWidth(), silkscreenEndSegments);
                } else {
                     return this.segmentedGeometry(precision).close().toOutlineGeometry(this.strokeWidth(), silkscreenEndSegments);
                }
            }
        },
        geometryTriggers, 1
    );


    this.mesh = this.deepCachedFunction("mesh", 
        function(info){
            var silkscreenHeight = (info && info.silkscreenHeight)? info.silkscreenHeight : 1;
            var holes = (info && info.holes)? info.holes : [];
            var boardThickness = (info && info.boardThickness)? info.boardThickness : 2;

            var geom = this.complexGeometry(info);
            var cutGeom = lib_geometry.Union([geom], holes);
            var mesh = (new lib_geometry.TriangleMesh()).fromPolygon(cutGeom, silkscreenHeight);
            // item has parent when it is a layered shape (can be on bottom)
            if(this.parent() && this.parent().layerIndex && this.parent().layerIndex.contains(1)){
                mesh.translate(0,0, -boardThickness - silkscreenHeight);
            }
            return mesh;

        },
        [this.complexGeometry], 1
    );
}
 

module.exports = SVGToMesh;